import api from '../../../../../api';
import { Actor, Line } from '../mini-dialog-types';

export type MiniDialogGetResponse = {
  id: string;
  name: string;
  moduleId: string;
  nodeId: string;
  image?: string;
  actors: Actor[];
  lines: Line[];
};

export async function getMiniDialog(
  token: string,
  moduleId: string,
  medialinkId: string,
  miniDialogId: string,
  studioGroup: string,
): Promise<MiniDialogGetResponse> {
  const { data } = await api.get<MiniDialogGetResponse>(
    `/studio/modules/${moduleId}/medialinks/${medialinkId}/mini-dialogs/${miniDialogId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        studioGroup,
      },
    },
  );

  return data;
}

export async function getSignedUrls(token: string, fileIds: string[]): Promise<{ [key: string]: string }> {
  const {
    data: { data },
  } = await api.post(
    '/s3-files/sign-urls?extendedTimeValidity=true',
    { ids: fileIds },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return data;
}
